import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils'
import RepaymentDefaultsModalUI from './RepaymentDefaultsModalUI.js'

class RepaymentDefaultsModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      status: null,
      defaultDate: this.props.selectedRepayment ? this.props.selectedRepayment.defaultDateISO : '',
      defaultDateError: null,
      cureDate: this.props.selectedRepayment ? this.props.selectedRepayment.cureDateISO : '',
      cureDateError: null,
      defaultReason: this.props.selectedRepayment ? this.props.selectedRepayment.defaultReason : '',
      defaultReasonError: null,
    }
  }

  render() {
    return (
      <RepaymentDefaultsModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        status={this.state.status}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        // form fields
        defaultDate={this.state.defaultDate}
        onDefaultDateChange={(defaultDate) => { this.setState({ defaultDate: defaultDate }) }}
        defaultDateError={this.state.defaultDateError}
        setDefaultDateError={(error) => { this.setState({ defaultDateError: error }) }}
        //
        cureDate={this.state.cureDate}
        onCureDateChange={(cureDate) => { this.setState({ cureDate: cureDate }) }}
        cureDateError={this.state.cureDateError}
        setCureDateError={(error) => { this.setState({ cureDateError: error }) }}
        //
        defaultReason={this.state.defaultReason}
        onDefaultReasonChange={(event) => { this.setState({ defaultReason: event.target.value }) }}
        defaultReasonError={this.state.defaultReasonError}
        setDefaultReasonError={(error) => { this.setState({ defaultReasonError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    let repayment = this.props.selectedRepayment
    if (!repayment ||
      prevProps.selectedRepayment && prevProps.selectedRepayment.scheduledDate === repayment.scheduledDate)
      return

    if (repayment.status == 'paid' || repayment.status == 'initiated') {
      this.setState({
        status: repayment.status,
        submitted: false,
        errorList: null
      })
    }

    if (repayment.status == 'unpaid') {
      let defaultReason = ''
      let defaultDateISO = ''
      let cureDateISO = ''
      if (repayment.defaultHistoryList.length) {
        let history = repayment.defaultHistoryList[0]
        defaultReason = history.defaultReason
        defaultDateISO = history.defaultDateISO
        cureDateISO = history.cureDateISO
      }
      this.setState({
        defaultReason: defaultReason,
        defaultDate: defaultDateISO,
        cureDate: cureDateISO,
        status: repayment.status,
        submitted: false,
        errorList: null
      })
    }
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/loans/${this.props.loan.loanId}/repayments/scheduledDates/${this.props.selectedRepayment.scheduledDate}/defaultDates`,
      this.onSubmitCallback, {
      defaultDate: this.state.defaultDate,
      cureDate: this.state.cureDate,
      defaultReason: this.state.defaultReason
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 100)
    }
  }

  onCancelClick = () => {
    this.setState({
      errorList: null,
      submitted: false,
    })
    this.props.onCancelClick()
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default RepaymentDefaultsModalSF
